/* REPORTS */
export const GET_REPORTS = "GET_REPORTS"
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS"
export const GET_REPORTS_FAIL = "GET_REPORTS_FAIL"


/* GET_REPORT_DETAIL */
export const GET_REPORT_DETAIL = "GET_REPORT_DETAIL"
export const GET_REPORT_DETAIL_SUCCESS = "GET_REPORT_DETAIL_SUCCESS"
export const GET_REPORT_DETAIL_FAIL = "GET_REPORT_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add REPORT
 */
 export const ADD_NEW_REPORT = "ADD_NEW_REPORT"
 export const ADD_REPORT_SUCCESS = "ADD_REPORT_SUCCESS"
 export const ADD_REPORT_FAIL = "ADD_REPORT_FAIL"
 
 /**
  * Edit REPORT
  */
 export const UPDATE_REPORT = "UPDATE_REPORT"
 export const UPDATE_REPORT_SUCCESS = "UPDATE_REPORT_SUCCESS"
 export const UPDATE_REPORT_FAIL = "UPDATE_REPORT_FAIL"
 
 /**
  * Delete REPORT
  */
 export const DELETE_REPORT = "DELETE_REPORT"
 export const DELETE_REPORT_SUCCESS = "DELETE_REPORT_SUCCESS"
 export const DELETE_REPORT_FAIL = "DELETE_REPORT_FAIL"
 

